import { authApi } from '../api/authApi';
import { clearStoredSession, getStoredRefreshToken } from './session';

/**
 * Ends the session in this browser and on the server: the refresh token is revoked, so the copies
 * left behind here - or already taken from here - can no longer mint access tokens.
 *
 * Best effort on the network side. A failed or slow revoke must never leave someone stuck in a
 * session they asked to leave, so local state is cleared first and the call is allowed to fail.
 */
export const endSession = async () => {
  const refreshToken = getStoredRefreshToken();
  clearStoredSession();

  if (!refreshToken) return;

  try {
    await authApi.logout(refreshToken);
  } catch {
    // The session is already gone locally; nothing useful to tell the user here.
  }
};

/** Revokes a refresh token that belonged to a session which had already lapsed. */
export const revokeLapsedRefreshToken = async (refreshToken: string) => {
  try {
    await authApi.logout(refreshToken);
  } catch {
    // Same as above: the browser has already forgotten this session.
  }
};
